import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseDataGroupFromConversation, RDataGroup} from './dataGroupModel';

/*
 * Runtime type.
 */

const RConversationJoinBatch = t.type({
  electedConversationId: t.number,
  dataGroups: t.readonlyArray(RDataGroup),
});

/*
 * Type.
 */

interface ConversationJoinBatchModel extends Readonly<t.TypeOf<typeof RConversationJoinBatch>> {}

/*
 * I/O methods.
 */

function parseConversationJoinBatch(src: any): ConversationJoinBatchModel {
  return {
    electedConversationId: src.elected_id,
    dataGroups: src.conversations && src.conversations.map(parseDataGroupFromConversation),
  };
}

/*
 * API type.
 */

export const ApiConversationJoinBatch = makeApiType(
  'ConversationJoinBatch',
  RConversationJoinBatch,
  parseConversationJoinBatch,
);
